import { useState } from 'react';

interface Client {
  id: number;
  name: string;
  image: string;
  followers: string;
  platform: string;
}

export default function ClientsSection() {
  const [showMore, setShowMore] = useState(false);
  const [showSection, setShowSection] = useState(false);

  const clients: Client[] = [
    {
      id: 1,
      name: 'أحمد السعيد',
      image: 'https://public.readdy.ai/ai/img_res/bb4b80162302c801e7f6ad1e4a96b1e0.jpg',
      followers: '2.5M',
      platform: 'Instagram'
    },
    {
      id: 2,
      name: 'سارة محمد',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Arab%20female%20content%20creator%20portrait%20with%20warm%20smile%20wearing%20elegant%20modern%20outfit%20against%20clean%20minimalist%20studio%20background%20with%20soft%20professional%20lighting%20high%20quality%20photography&width=400&height=400&seq=client2&orientation=squarish',
      followers: '1.8M',
      platform: 'TikTok'
    },
    {
      id: 3,
      name: 'شركة النجاح',
      image: 'https://readdy.ai/api/search-image?query=Modern%20professional%20business%20team%20portrait%20diverse%20group%20in%20contemporary%20office%20setting%20against%20clean%20minimalist%20background%20with%20soft%20professional%20lighting%20corporate%20photography%20style&width=400&height=400&seq=client3&orientation=squarish',
      followers: '850K',
      platform: 'LinkedIn'
    },
    {
      id: 4,
      name: 'خالد العمري',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Arab%20male%20entrepreneur%20portrait%20with%20confident%20expression%20wearing%20smart%20casual%20attire%20against%20clean%20minimalist%20studio%20background%20with%20soft%20professional%20lighting%20high%20quality%20photography&width=400&height=400&seq=client4&orientation=squarish',
      followers: '3.2M',
      platform: 'YouTube'
    },
    {
      id: 5,
      name: 'نورة الحسن',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Arab%20female%20influencer%20portrait%20with%20genuine%20smile%20wearing%20stylish%20contemporary%20outfit%20against%20clean%20minimalist%20studio%20background%20with%20soft%20professional%20lighting%20high%20quality%20photography&width=400&height=400&seq=client5&orientation=squarish',
      followers: '1.5M',
      platform: 'Instagram'
    },
    {
      id: 6,
      name: 'مؤسسة الإبداع',
      image: 'https://readdy.ai/api/search-image?query=Modern%20creative%20business%20team%20portrait%20professional%20group%20in%20stylish%20contemporary%20workspace%20against%20clean%20minimalist%20background%20with%20soft%20professional%20lighting%20corporate%20photography%20style&width=400&height=400&seq=client6&orientation=squarish',
      followers: '920K',
      platform: 'Twitter'
    },
    {
      id: 7,
      name: 'فيصل الشمري',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Arab%20male%20content%20creator%20portrait%20with%20friendly%20smile%20wearing%20modern%20casual%20outfit%20against%20clean%20minimalist%20studio%20background%20with%20soft%20professional%20lighting%20high%20quality%20photography&width=400&height=400&seq=client7&orientation=squarish',
      followers: '2.1M',
      platform: 'TikTok'
    },
    {
      id: 8,
      name: 'ريم الأحمد',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Arab%20female%20entrepreneur%20portrait%20with%20confident%20smile%20wearing%20elegant%20business%20casual%20attire%20against%20clean%20minimalist%20studio%20background%20with%20soft%20professional%20lighting%20high%20quality%20photography&width=400&height=400&seq=client8&orientation=squarish',
      followers: '1.3M',
      platform: 'Instagram'
    }
  ];

  const displayedClients = showMore ? clients : clients.slice(0, 6);

  return (
    <section id="clients" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Toggle Button */}
        {!showSection && (
          <div className="text-center">
            <button
              onClick={() => setShowSection(true)}
              className="group relative w-32 h-32 mx-auto bg-gradient-to-br from-yellow-400 to-blue-600 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-500 hover:scale-110 cursor-pointer"
            >
              <div className="absolute inset-0 bg-white/20 rounded-full animate-ping"></div>
              <div className="relative flex flex-col items-center justify-center h-full">
                <i className="ri-team-line text-5xl text-white mb-2"></i>
                <span className="text-sm font-bold text-white" style={{ fontFamily: 'Cairo, sans-serif' }}>
                  عملاؤنا
                </span>
              </div>
            </button>
          </div>
        )}

        {/* Section Content */}
        <div
          className={`overflow-hidden transition-all duration-700 ${
            showSection ? 'max-h-[10000px] opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          {/* Section Header */}
          <div className="text-center mb-20">
            <div className="flex items-center justify-center gap-4 mb-6">
              <h2 className="text-5xl md:text-6xl font-bold text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
                عملاؤنا
              </h2>
              <button
                onClick={() => setShowSection(false)}
                className="w-12 h-12 flex items-center justify-center bg-gray-200 hover:bg-gray-300 rounded-full transition-all duration-300 cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-700"></i>
              </button>
            </div>
            <div className="w-24 h-1.5 bg-gradient-to-r from-yellow-400 via-yellow-500 to-blue-600 mx-auto rounded-full"></div>
            <p className="text-xl text-gray-600 mt-6 max-w-2xl mx-auto" style={{ fontFamily: 'Cairo, sans-serif' }}>
              نفخر بثقة عملائنا من المشاهير والشركات الرائدة
            </p>
          </div>

          {/* Clients Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 mb-12">
            {displayedClients.map((client, index) => (
              <div
                key={client.id}
                className="group relative bg-gradient-to-br from-gray-50 to-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer"
                style={{
                  animation: `fadeInScale 0.6s ease-out ${index * 0.1}s both`
                }}
              >
                {/* Image Container */}
                <div className="relative w-full h-80 overflow-hidden">
                  <img
                    src={client.image}
                    alt={client.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                  {/* Followers Count */}
                  <div className="absolute top-4 left-4 px-4 py-2 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-full text-sm font-bold text-gray-900 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    {client.followers}
                  </div>
                </div>

                {/* Client Info */}
                <div className="p-6 text-center">
                  <h3 className="text-2xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors duration-300 mb-3" style={{ fontFamily: 'Cairo, sans-serif' }}>
                    {client.name}
                  </h3>
                  
                  {/* Platform Icon */}
                  <div className="flex items-center justify-center gap-2 mb-3">
                    <div className="w-8 h-8 flex items-center justify-center">
                      {client.platform === 'Instagram' && <i className="ri-instagram-line text-2xl text-pink-500"></i>}
                      {client.platform === 'TikTok' && <i className="ri-tiktok-line text-2xl text-gray-900"></i>}
                      {client.platform === 'LinkedIn' && <i className="ri-linkedin-line text-2xl text-blue-600"></i>}
                      {client.platform === 'YouTube' && <i className="ri-youtube-line text-2xl text-red-600"></i>}
                      {client.platform === 'Twitter' && <i className="ri-twitter-x-line text-2xl text-blue-400"></i>}
                    </div>
                  </div>

                  <div className="flex items-center justify-center gap-2 text-gray-600">
                    <i className="ri-user-follow-line text-yellow-500"></i>
                    <span className="text-sm font-semibold" style={{ fontFamily: 'Cairo, sans-serif' }}>
                      {client.followers} متابع
                    </span>
                  </div>
                </div>

                {/* Decorative Border */}
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-yellow-400 rounded-3xl transition-all duration-500"></div>
              </div>
            ))}
          </div>

          {/* Show More Button */}
          <div className="text-center">
            <button
              onClick={() => setShowMore(!showMore)}
              className="px-12 py-5 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-lg font-semibold rounded-full hover:from-blue-700 hover:to-blue-800 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{ fontFamily: 'Cairo, sans-serif' }}
            >
              {showMore ? (
                <>
                  <i className="ri-arrow-up-line ml-2"></i>
                  عرض أقل
                </>
              ) : (
                <>
                  <i className="ri-arrow-down-line ml-2"></i>
                  عرض المزيد من العملاء
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </section>
  );
}
